import Content from "./content/content";
import Navigation from "./navigation/navigation";
import styles from "./main.module.css";
import React from "react";
import Store from "../../global/store";

const Main = () => {
  return (
    <Store>
      <div className={`container mx-auto flex ` + styles.main}>
        <Navigation />
        <Content />
      </div>
    </Store>
  );
};

export default Main;
